import { Children } from 'react';
import { CellRender } from './components/Cell';
import { RowRender } from './components/Row';
import { EmptyDataRender } from './components/EmptyData';
import { SelectButtonRender } from './components/SelectButton';

/**
 * @summary Обработчик children для таблицы.
 *
 * @todo Поправить типы, когда реакт дорастет до нормальных типов.
 */
export const useChildren = (children: { props: { children: JSX.Element | JSX.Element[] } }) => {
  const getElement = (needType: string) =>
    (Children.toArray(children.props.children) as JSX.Element[]).find(
      (cur) => needType === cur.type.displayName
    ) || null;

  const row: RowRender | null = getElement('Row');
  const emptyData: EmptyDataRender | null = getElement('EmptyData');
  const selectButton: SelectButtonRender<any> | null = getElement('SelectButton');

  if (!row) {
    throw new Error('В шаблоне таблицы нет элемента Row');
  }

  const rowChildren = Children.toArray(row.props.children) as CellRender<any>[];

  return [{ row, rowChildren }, emptyData, selectButton] as const;
};
